<template>
  <div class="news">

    <div>
      <router-link :to="'/'" v-for="(item,index) in page_arrs" :key="index" class="margin-bottom-20">
        <div class="newslist">
          <div class="row">
             <div class="col-md-3">
                <img :src="item.imgUrl" width="203" height="124">
              </div>
            <div class="col-md-8">
              <div class="title"> {{item.title}}<span class="end">三天后截止</span></div>
              <div class="date"> 考试时间：<i class="iconfont"></i>{{item.date}}&nbsp;&nbsp;至 &nbsp;&nbsp;{{item.date}}</div>
              <div class="date"> 考试时长：<strong class="margin-right-20">1小时30分</strong>  共计：<strong class="text-danger">120</strong>&nbsp;&nbsp;道题目</div>
            </div>
            <div class="col-md-1" style="margin:0;">
              <div class="text-center">
                <button class="ks">去考试</button>
              </div>

            </div>
          </div>
        </div>
      </router-link>
      </div>
    <div class="text-center margin-bottom-20">
    <div class="page">
      <button class="btn btn-default margin-right-10" :class="{'active':activenum === 0}" type="submit" @click="primaryPage" >首页</button>
      <button class="btn btn-default margin-right-10" type="submit" @click="prePage" :class="{'active':activenum === 1}">上页</button>
      <button class="btn btn-default margin-right-10" type="submit" @click="nextPage" :class="{'active':activenum === 2}">下页</button>
      <button class="btn btn-default margin-right-10" type="submit" @click="lastPage" :class="{'active':activenum === 3}">尾页</button>
      <button class="btn btn-default" type="submit" style="background: none">{{current_page}}/{{Math.ceil(arrs.length/pagesize)}}</button>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'NewsList',
  props: {
    arrs: Array
  },
  data: function () {
    return {
      currentPage: 1, // 当前页号
      activenum: 0, // 每页大小
      pagesize: 5
    }
  },
  computed: {
    page_arrs () {
      let {currentPage, pagesize} = this
      return this.arrs.slice((currentPage - 1) * pagesize, currentPage * pagesize)
    },
    current_page () {
      return this.currentPage
    }
  },
  methods: {
    primaryPage () {
      this.currentPage = 1
      this.activenum = 0
    },
    prePage () {
      if (this.currentPage === 1) {
        this.activenum = 1
        return
      }
      this.currentPage = this.currentPage - 1
      this.activenum = 1
    },
    nextPage () {
      if (this.currentPage === Math.ceil(this.arrs.length / this.pagesize)) {
        return
      }
      this.currentPage = this.currentPage + 1
      this.activenum = 2
    },
    lastPage () {
      this.currentPage = Math.ceil(this.arrs.length / this.pagesize)
      this.activenum = 3
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/mixins.styl'
  .news{
    background:#fff;
  }
  .newslist{
    background:#fbfbfb;
    padding:20px;
    margin-bottom:20px;
    height:164px;
    .title{
      font-size:16px;
      line-height:24px;
      ellipsis2();
      margin-bottom:10px;
      font-size:18px;
      margin-right:20px;
    }
    &:hover{
      box-shadow: 0px 0px 10px #999;
    }
    .author{
      font-size:14px;
      color:#999;
    }
    .col-md-8{
       border-right:1px dashed #efefef;
      -webkit-box-flex: 0;
      flex: 0 0 70%;
      max-width: 70%;
      .date{
        color:#999;
      }
    }
    .col-md-1{
      -webkit-box-flex: 0;
      flex: 0 0 10%;
      max-width: 10%;
      .date{
        color:#999;
      }
    }
    .col-md-3{
      -webkit-box-flex: 0;
      flex: 0 0 20%;
      max-width: 20%;
      .date{
        font-size:30px;
        padding-top:10px;
        margin-bottom:20px;
      }
      .year{
        color:#999;
      }
    }

  }
  .btn{
    width:80px;
    height:32px;
    line-height:32px;
    padding:0;
    background:#cbccce;
    text-align:center;
    color:#fff;
    border:none;
  }
  .active{
    background: $bgColor;
  }
  .end{
    display:inline-block;
    width:100px;
    height:28px;
    line-height:28px;
    border:1px solid #f00;
    border-radius:16px;
    text-align:center;
    color:#f00;
    font-size:14px;
  }
  .date{
    line-height:24px;
    .text-danger{
      color:#ff9933 !important;
    }
  }
  .ks{
    padding:4px 15px;
    background:$bgColor;
    color:#fff;
    border-radius:20px;
    margin-top:50px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/examination/components/NewsList.vue